module.exports = __webpack_public_path__ + "img/riga2.6cb2c072.png";